var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9176_948",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9176_948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12C8.9 12 7.95833 11.6083 7.175 10.825C6.39167 10.0417 6 9.1 6 8C6 6.9 6.39167 5.95833 7.175 5.175C7.95833 4.39167 8.9 4 10 4C11.1 4 12.0417 4.39167 12.825 5.175C13.6083 5.95833 14 6.9 14 8C14 9.1 13.6083 10.0417 12.825 10.825C12.0417 11.6083 11.1 12 10 12ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V17.2C2 16.65 2.14167 16.1333 2.425 15.65C2.70833 15.1667 3.1 14.8 3.6 14.55C4.45 14.1167 5.40833 13.75 6.475 13.45C7.54167 13.15 8.71667 13 10 13H10.6625C10.8708 13 11.0833 13.0167 11.3 13.05C11.6333 13.0833 11.85 13.2583 11.95 13.575C12.05 13.8917 11.9833 14.1667 11.75 14.4L11.325 14.825C10.8083 15.3417 10.5167 15.95 10.45 16.65C10.3833 17.35 10.5417 17.9917 10.925 18.575C11.125 18.8917 11.1542 19.2083 11.0125 19.525C10.8708 19.8417 10.6333 20 10.3 20H4ZM15.55 17.6L19.9 13.25C20.0833 13.0667 20.3167 12.975 20.6 12.975C20.8833 12.975 21.1167 13.0667 21.3 13.25C21.4833 13.4333 21.575 13.6667 21.575 13.95C21.575 14.2333 21.4833 14.4667 21.3 14.65L16.25 19.7C16.05 19.9 15.8167 20 15.55 20C15.2833 20 15.05 19.9 14.85 19.7L12.8 17.65C12.6167 17.4667 12.525 17.2333 12.525 16.95C12.525 16.6667 12.6167 16.4333 12.8 16.25C12.9833 16.0667 13.2167 15.975 13.5 15.975C13.7833 15.975 14.0167 16.0667 14.2 16.25L15.55 17.6Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.dcca9031563f1c05fd570a460e65ef12.svg";
export { ForwardRef as ReactComponent };